var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.84 2.61a5.5 5.5 0 0 0-7.78 0L11 3.67 9.94 2.61a5.501 5.501 0 1 0-7.78 7.78l1.06 1.06L11 19.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78Z",
    stroke: "#EEE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgHeart;